module.exports = __webpack_public_path__ + "770dc3befffb02220f5ccb1b3c371027.pdf";